module.exports = __webpack_public_path__ + "static/media/tasks.be411a74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/tasks.svg
// module id = 6539
// module chunks = 0